<script>
import PageHeader from "../../layout/PageHeader.vue";
  export default {
      name: "Page",
      components: {
            PageHeader
      },
      setup(){
        return {PageHeader}
      }
  }

</script>
<style lang="sass">
    @import "../../common/styles/settings"
    @import page-sitemap


</style>
